import NewProgramButton from './NewProgramButton.vue';

export default NewProgramButton;



// WEBPACK FOOTER //
// ./src/pages/event/card/newProgramButton/index.ts